import { useTranslation } from 'react-i18next'
import { ChevronLeftIcon } from '@heroicons/react/24/outline'

interface AppBarProps {
  title: string
  showBack?: boolean
  onBack?: () => void
  rightSlot?: React.ReactNode
}

export default function AppBar({ title, showBack = false, onBack, rightSlot }: AppBarProps) {
  const { t } = useTranslation('common')
  return (
    <div className="h-14 bg-primary flex items-center px-4 gap-3">
      {showBack && (
        <button onClick={onBack} aria-label={t('actions.back')} className="w-10 h-10 flex items-center justify-center -ml-2 text-white">
          <ChevronLeftIcon className="w-6 h-6" />
        </button>
      )}
      <h1 className="flex-1 text-white text-lg font-semibold truncate min-w-0">
        {title}
      </h1>
      {rightSlot && <div className="flex-shrink-0">{rightSlot}</div>}
    </div>
  )
}
